import type { SiteManagerState } from './useSiteManagerState';
import { createDataLoaders } from './handlers/dataLoaders';
import { createPageHandlers } from './handlers/pageHandlers';
import { createSiteHandlers } from './handlers/siteHandlers';

interface HandlerDependencies {
  siteId: string | undefined;
  navigate: (path: string) => void;
  state: SiteManagerState;
}

export const createSiteManagerHandlers = ({ siteId, navigate, state }: HandlerDependencies) => {
  const dataLoaders = createDataLoaders({ siteId, navigate, state });
  const pageHandlers = createPageHandlers({ siteId, state });
  const siteHandlers = createSiteHandlers({
    siteId,
    state,
    loadBlogData: dataLoaders.loadBlogData,
  });

  return {
    ...dataLoaders,
    ...pageHandlers,
    ...siteHandlers,
  };
};
